import { injectable, inject, optional } from "inversify";
import { DITypes } from "@/core/@types/types";
import type { IEvent } from "@/core/plugins/Events/Event";
import * as HttpTokenInterceptor from "./middleware/HttpTokenInterceptor";
import { AxiosInstance } from "axios";
import { AxiosAdapter } from "./AxiosAdapter";

@injectable()
export default class GithubAxiosAdapter extends AxiosAdapter {
  constructor(
    @inject(DITypes.EVENT) event: IEvent,
    @inject(DITypes.INTERCEPTOR)
    @optional()
    axiosTokenInterceptor?: HttpTokenInterceptor.IHttpTokenInterceptor<AxiosInstance>
  ) {
    super(event, axiosTokenInterceptor);

    this.setup("", false, false, false);
  }
}
